const auth = {
  login: {
    title: 'Bienvenido',
    subtitle: 'Inicia sesion en tu cuenta',
    username: 'Email',
    password: 'Contrasena',
    sign_in: 'Iniciar Sesion',
    remember_me: 'Recuerdame',
    forgot_password: 'Olvidaste tu contrasena?',
    error: 'Usuario o contrasena incorrectos',
    loading: 'Iniciando sesion...',
  },
  logout: {
    title: 'Cerrar Sesion',
    message: 'Estas seguro de que quieres cerrar sesion?',
    confirm: 'Cerrar sesion',
    cancel: 'Cancelar',
  },
  errors: {
    invalid_credentials: 'Credenciales invalidas',
    session_expired: 'Tu sesion ha expirado',
    unauthorized: 'No tienes permisos para acceder a este recurso',
    forbidden: 'Acceso denegado',
    network_error: 'Error de conexion',
  },
  password: {
    change_title: 'Cambiar Contrasena',
    current: 'Contrasena actual',
    new_password: 'Nueva contrasena',
    confirm: 'Confirmar nueva contrasena',
    requirements: {
      title: 'La contrasena debe tener:',
      minLength: 'Al menos 8 caracteres',
      uppercase: 'Una letra mayuscula',
      lowercase: 'Una letra minuscula',
      number: 'Un numero',
      special: 'Un caracter especial (!@#$%^&*)',
    },
    errors: {
      mismatch: 'Las contrasenas no coinciden',
      weak: 'La contrasena es demasiado debil',
      same: 'La nueva contrasena debe ser diferente a la actual',
    },
    success: 'Contrasena actualizada correctamente',
  },
  roles: {
    Admin: 'Administrador',
    User: 'Usuario',
    ReadOnly: 'Solo Lectura',
  },
  session_expiry: {
    title: 'Sesion a punto de expirar',
    message: 'Tu sesion expirara pronto. Quieres extenderla?',
    extend: 'Extender sesion',
  },
};

export default auth;
